// useCustomerUsers.ts

import { useQuery } from '@tanstack/react-query';
import { getCustomerUsers } from '../services/apiCustomers.ts';

export function useCustomerUsers(customerId: number | null) {
  const {
    data: customerUsers,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['customerUsers', customerId],
    queryFn: () => (customerId ? getCustomerUsers(customerId) : []),
    enabled: !!customerId,
  });

  return { customerUsers, isLoading, error, refetch };
}
